"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-eight/sections/serviceSlider.tsx */

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import { FC, ComponentProps, Key, ReactNode } from "react";

type ServiceSliderSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/icons/services-icon-5.svg" | "/Templates/Doccure/img/icons/services-icon-6.svg" | "/Templates/Doccure/img/icons/services-icon-7.svg" */
    src: string;
    /** Detected variants: "/Templates/Doccure/img/service/services-img-1.jpg" | "/Templates/Doccure/img/service/services-img-2.jpg" | "/Templates/Doccure/img/service/services-img-3.jpg" */
    imageWithBasePath0Src: string;
    /** Detected variants: "Cataract Surgery" | "LASIK & Surgery" | "Retina Care" */
    link0Text: ReactNode;
    /** Detected variants: "Laser-assisted cataract removal" | "Safe & precise vision correction" | "Diabetic & retinal disorders" */
    p0Text: ReactNode;
    /** Detected variants: "slide-item" */
    className?: string;
    /** Detected variants: "services-item-eight wow fadeInUp" */
    div0ClassName?: string;
    /** Detected variants: "services-overlay" */
    div0ClassName2?: string;
    /** Detected variants: "services-icon" */
    div0ClassName3?: string;
    /** Detected variants: "service-icon" */
    alt?: string;
    /** Detected variants: "img-fluid" */
    imageWithBasePath0ClassName?: string;
    /** Detected variants: "icon" */
    link0ClassName?: string;
    /** Detected variants: "#" */
    href?: string;
    /** Detected variants: "isax isax-arrow-right-1" */
    i0ClassName?: string;
    /** Detected variants: "services-img" */
    imageWithBasePath0Alt?: string;
    /** Detected variants: "img-fluid img-one" */
    imageWithBasePath0ClassName2?: string;
    /** Detected variants: "services-content" */
    div1ClassName?: string;
    /** Detected variants: "custom-title" */
    h30ClassName?: string;
    /** Detected variants: "#" */
    link0Href?: string;
    /** Detected variants: "description" */
    p0ClassName?: string;
};
export type HomeEightServiceSliderGeneratedProps = {
    divDiv0Swiper0SwiperProps?: Partial<ComponentProps<typeof Swiper>>;
    divDiv1Button0ButtonVisible?: boolean;
    divDiv1Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv1Button0ButtonProps?: Partial<ComponentProps<"button">>;
    divDiv1Button1ButtonVisible?: boolean;
    divDiv1Button1ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv1Button1ButtonProps?: Partial<ComponentProps<"button">>;
    swiperSlideSwiperSlideProps?: Partial<ComponentProps<typeof SwiperSlide>> | ((item: ServiceSliderSlidesItem) => Partial<ComponentProps<typeof SwiperSlide>>);
    swiperSlideDiv0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServiceSliderSlidesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    swiperSlideDiv0Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: ServiceSliderSlidesItem) => Partial<ComponentProps<typeof SmartLink>>);
    swiperSlideDiv0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServiceSliderSlidesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    swiperSlideDiv0Div1H30H3Props?: Partial<ComponentProps<"h3">> | ((item: ServiceSliderSlidesItem) => Partial<ComponentProps<"h3">>);
    swiperSlideDiv0Div1H30Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: ServiceSliderSlidesItem) => Partial<ComponentProps<typeof SmartLink>>);
    serviceSliderSlides: ServiceSliderSlidesItem[];
    serviceSliderSlidesItemWrapper?: (item: ServiceSliderSlidesItem, content: ReactNode) => ReactNode;
    serviceSliderSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    serviceSliderSlidesLinkVisible?: boolean;
    serviceSliderSlidesLinkRenderer?: (item: ServiceSliderSlidesItem, defaultNode: ReactNode) => ReactNode;
    serviceSliderSlidesImageVisible?: boolean;
    serviceSliderSlidesImageRenderer?: (item: ServiceSliderSlidesItem, defaultNode: ReactNode) => ReactNode;
    serviceSliderSlidesH3Visible?: boolean;
    serviceSliderSlidesH3Renderer?: (item: ServiceSliderSlidesItem, defaultNode: ReactNode) => ReactNode;
    serviceSliderSlidesLinkProps?: Partial<ComponentProps<typeof SmartLink>> | ((item: ServiceSliderSlidesItem) => Partial<ComponentProps<typeof SmartLink>>);
    serviceSliderSlidesImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: ServiceSliderSlidesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    serviceSliderSlidesH3Props?: Partial<ComponentProps<"h3">> | ((item: ServiceSliderSlidesItem) => Partial<ComponentProps<"h3">>);
    serviceSliderSlidesSwiperSlideProps?: Partial<ComponentProps<typeof SwiperSlide>> | ((item: ServiceSliderSlidesItem) => Partial<ComponentProps<typeof SwiperSlide>>);
};

const HomeEightServiceSliderGenerated: FC<HomeEightServiceSliderGeneratedProps> = ({
    divDiv1Button0ButtonVisible,
    divDiv1Button0ButtonRenderer,
    divDiv1Button0ButtonProps,
    divDiv1Button1ButtonVisible,
    divDiv1Button1ButtonRenderer,
    divDiv1Button1ButtonProps,
    divDiv0Swiper0SwiperProps,
    swiperSlideDiv0Div0Div0ImageWithBasePath0ImageProps,
    swiperSlideDiv0Div0Div0Link0LinkProps,
    swiperSlideDiv0Div0ImageWithBasePath0ImageProps,
    swiperSlideDiv0Div1H30H3Props,
    swiperSlideDiv0Div1H30Link0LinkProps,
    swiperSlideSwiperSlideProps,
    serviceSliderSlides,
    serviceSliderSlidesItemWrapper,
    serviceSliderSlidesRenderer,
    serviceSliderSlidesLinkVisible,
    serviceSliderSlidesLinkRenderer,
    serviceSliderSlidesImageVisible,
    serviceSliderSlidesImageRenderer,
    serviceSliderSlidesH3Visible,
    serviceSliderSlidesH3Renderer,
    serviceSliderSlidesLinkProps,
    serviceSliderSlidesImageProps,
    serviceSliderSlidesH3Props,
    serviceSliderSlidesSwiperSlideProps,
}) => {
    return (
        <div className="services">
            <div className="service-slider-eight">
                <Swiper modules={[Navigation]} loop speed={2000} centeredSlides navigation={{
                    prevEl: ".services-prev",
                    nextEl: ".services-next",
                }} breakpoints={{
                    1400: { slidesPerView: 3 },
                    1200: { slidesPerView: 3 },
                    992: { slidesPerView: 3 },
                    768: {
                        slidesPerView: 2,
                        centeredSlides: false
                    },
                    576: {
                        slidesPerView: 1,
                        centeredSlides: false
                    }
                }} {...(divDiv0Swiper0SwiperProps ?? {})}>
                    {renderCollectionNode(
                        serviceSliderSlides,
                        (item: ServiceSliderSlidesItem) => (
                            <SwiperSlide className={item.className ?? "slide-item"} {...(typeof serviceSliderSlidesSwiperSlideProps === "function" ? serviceSliderSlidesSwiperSlideProps(item) : (serviceSliderSlidesSwiperSlideProps ?? {}))} {...(typeof swiperSlideSwiperSlideProps === "function" ? swiperSlideSwiperSlideProps(item) : (swiperSlideSwiperSlideProps ?? {}))} key={item.key}>
                                <div className={item.div0ClassName ?? "services-item-eight wow fadeInUp"}>
                                    <div className={item.div0ClassName2 ?? "services-overlay"}>
                                        {renderItemNode(serviceSliderSlidesImageVisible, serviceSliderSlidesImageRenderer, item, (
                                            <SmartImage src={item.imageWithBasePath0Src} alt={item.imageWithBasePath0Alt ?? "services-img"} className={item.imageWithBasePath0ClassName2 ?? "img-fluid img-one"} {...(typeof serviceSliderSlidesImageProps === "function" ? serviceSliderSlidesImageProps(item) : (serviceSliderSlidesImageProps ?? {}))} {...(typeof swiperSlideDiv0Div0ImageWithBasePath0ImageProps === "function" ? swiperSlideDiv0Div0ImageWithBasePath0ImageProps(item) : (swiperSlideDiv0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                        ))}
                                        <div className={item.div0ClassName3 ?? "services-icon"}>
                                            {renderItemNode(serviceSliderSlidesImageVisible, serviceSliderSlidesImageRenderer, item, (
                                                <SmartImage src={item.src} alt={item.alt ?? "service-icon"} className={item.imageWithBasePath0ClassName ?? "img-fluid"} {...(typeof serviceSliderSlidesImageProps === "function" ? serviceSliderSlidesImageProps(item) : (serviceSliderSlidesImageProps ?? {}))} {...(typeof swiperSlideDiv0Div0Div0ImageWithBasePath0ImageProps === "function" ? swiperSlideDiv0Div0Div0ImageWithBasePath0ImageProps(item) : (swiperSlideDiv0Div0Div0ImageWithBasePath0ImageProps ?? {}))} />
                                            ))}
                                            {renderItemNode(serviceSliderSlidesLinkVisible, serviceSliderSlidesLinkRenderer, item, (
                                                <SmartLink href={item.href ?? "#"} className={item.link0ClassName ?? "icon"} {...(typeof serviceSliderSlidesLinkProps === "function" ? serviceSliderSlidesLinkProps(item) : (serviceSliderSlidesLinkProps ?? {}))} {...(typeof swiperSlideDiv0Div0Div0Link0LinkProps === "function" ? swiperSlideDiv0Div0Div0Link0LinkProps(item) : (swiperSlideDiv0Div0Div0Link0LinkProps ?? {}))}>
                                                    <i className={item.i0ClassName ?? "isax isax-arrow-right-1"}></i>
                                                </SmartLink>
                                            ))}
                                        </div>
                                    </div>
                                    <div className={item.div1ClassName ?? "services-content"}>
                                        {renderItemNode(serviceSliderSlidesH3Visible, serviceSliderSlidesH3Renderer, item, (
                                            <h3 className={item.h30ClassName ?? "custom-title"} {...(typeof serviceSliderSlidesH3Props === "function" ? serviceSliderSlidesH3Props(item) : (serviceSliderSlidesH3Props ?? {}))} {...(typeof swiperSlideDiv0Div1H30H3Props === "function" ? swiperSlideDiv0Div1H30H3Props(item) : (swiperSlideDiv0Div1H30H3Props ?? {}))}>
                                                {renderItemNode(serviceSliderSlidesLinkVisible, serviceSliderSlidesLinkRenderer, item, (
                                                    <SmartLink href={item.link0Href ?? "#"} {...(typeof serviceSliderSlidesLinkProps === "function" ? serviceSliderSlidesLinkProps(item) : (serviceSliderSlidesLinkProps ?? {}))} {...(typeof swiperSlideDiv0Div1H30Link0LinkProps === "function" ? swiperSlideDiv0Div1H30Link0LinkProps(item) : (swiperSlideDiv0Div1H30Link0LinkProps ?? {}))}>{item.link0Text}</SmartLink>
                                                ))}
                                            </h3>
                                        ))}
                                        <p className={item.p0ClassName ?? "description"}>{item.p0Text}</p>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ),
                        serviceSliderSlidesItemWrapper,
                        serviceSliderSlidesRenderer
                    )}
                </Swiper>
            </div>
            <div className="slide-btn">
                {renderNode(divDiv1Button0ButtonVisible, divDiv1Button0ButtonRenderer, (
                    <button type="button" className="slick-arrow services-prev" {...(divDiv1Button0ButtonProps ?? {})}>
                        <i className="isax isax-arrow-left-2"></i>
                    </button>
                ))}
                {renderNode(divDiv1Button1ButtonVisible, divDiv1Button1ButtonRenderer, (
                    <button type="button" className="slick-arrow services-next" {...(divDiv1Button1ButtonProps ?? {})}>
                        <i className="isax isax-arrow-right-3"></i>
                    </button>
                ))}
            </div>
        </div>
    );
};

export default HomeEightServiceSliderGenerated;
